module.exports = __webpack_public_path__ + "static/media/Zapier-Second-Image.ca1a2332.jpg";